/** Retired — no passwords in Firebase Phone Auth. Redirects to /login. */
import { Navigate } from "react-router-dom";
export default function ResetPassword() { return <Navigate to="/login" replace />; }
